import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { LocalAuthService } from '../services/auth.service';
import { TenantService } from '../services/tenant.service';

export const authHomeGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(LocalAuthService);
  const tenantService = inject(TenantService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        return of(true as boolean | UrlTree);
      }

      return tenantService.loadTenants().pipe(
        take(1),
        map((tenants) => {
          const tenantId =
            tenantService.getActiveTenantId() ?? tenants[0]?.tenantId;
          return tenantId
            ? router.createUrlTree(['/', tenantId, 'home'])
            : (true as boolean | UrlTree);
        }),
        catchError(() => of(true as boolean | UrlTree)),
      );
    }),
  );
};
